export function getGridPosition(
  itemId: string
): { row: number; col: number } | null {
  const gridContainer = document.querySelector('#products-grid')
  if (!gridContainer) return null

  const gridItems = Array.from(gridContainer.children) as HTMLElement[]
  const columnCount =
    getComputedStyle(gridContainer).gridTemplateColumns.split(' ').length
  const itemIndex = gridItems.findIndex(
    (item) => item.id === 'product-' + itemId
  )
  if (itemIndex === -1) return null

  const row = Math.floor(itemIndex / columnCount) + 1
  const col = (itemIndex % columnCount) + 1

  return { row, col }
}
